// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"6f1468404c93e9659feb","668":"20574b6c44af5e6bca13","746":"b6589ee7d8ebc61e8fba"}[chunkId] + ".js";
};